import { SET_FILTERS, CLEAR_FILTERS, SET_SUB_FILTERS, CLEAR_SUB_FILTERS, HANDLE_SEARCH , SET_PAKKET_FILTERS } from "../actions/actionTypes"

const initialState = {
  filters: [],
  pakketFilters: [],
  subFilters: [],
  searchValue: ''
}

export default function(state=initialState, action){
  switch(action.type){

    case SET_FILTERS:
      return {
        ...state,
        filters: action.payload
      }

      case SET_PAKKET_FILTERS:
        return{
          ...state,
          pakketFilters: action.payload
        }
  

    case CLEAR_FILTERS:
      return{
        ...state,
        filters: []
      }

    case SET_SUB_FILTERS:
      return {
        ...state,
        subFilters: action.payload
      }

    case CLEAR_SUB_FILTERS:
      return{
        ...state,
        subFilters: []
      }

    case HANDLE_SEARCH:
      return{
        ...state,
        searchValue: action.payload
      }

    default:
        return state
  }
}